import { useRouter } from 'next/router';
import { useState } from 'react';

import { Box, Tab, Tabs, Grid, Typography, Skeleton, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { StyleTab, Title } from './style';

import { useBreakpoint, useDegreeCourse } from '@helpers/use';
import CoursesCard from 'src/components/molecules/courseCard/card';

export enum ActiveTabEnum {
  ALL = '',
  MANDATORY = 'Mandatory',
  ELECTIVE = 'Elective',
}

export const CoursesSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { isMobile } = useBreakpoint();
  const [activeTab, setActiveTab] = useState<ActiveTabEnum>(ActiveTabEnum.ALL);

  const router = useRouter();

  const degreeId = router.query.degreeIdName as string;

  const { courses, isLoading } = useDegreeCourse(degreeId, { degreeCourseType: activeTab });

  const onChange = (_event: React.SyntheticEvent, newValue: ActiveTabEnum) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      mb={{
        xs: 8,
        md: 10,
      }}
    >
      <Title>{t('degree_landing_page.course_section.title')}</Title>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box
          sx={{
            width: '100%',
            borderBottom: 1,
            borderColor: 'divider',
            mb: 5,
            [theme.breakpoints.up('sm')]: {
              width: 536,
            },
          }}
        >
          <Tabs variant={isMobile ? 'fullWidth' : 'standard'} value={activeTab} onChange={onChange} centered>
            <StyleTab
              id="courses-tab-all"
              label={t('degree_landing_page.course_section.tabs.all_course')}
              value={ActiveTabEnum.ALL}
            />
            <StyleTab
              id="courses-tab-mandatory"
              label={t('degree_landing_page.course_section.tabs.mandatory')}
              value={ActiveTabEnum.MANDATORY}
            />
            <StyleTab
              id="courses-tab-elective"
              label={t('degree_landing_page.course_section.tabs.elective')}
              value={ActiveTabEnum.ELECTIVE}
            />
          </Tabs>
        </Box>
        <Box ml={-1} width="100%">
          <Grid container spacing={1}>
            {(isLoading ? Array.from(new Array(12)) : courses).map((course) => (
              <Grid item xs={12} lg={3}>
                {course ? (
                  <CoursesCard course={course} key={`course-${course.id}`} />
                ) : (
                  <Skeleton
                    sx={{
                      borderRadius: '8px',
                      height: 80,
                      [theme.breakpoints.up('md')]: {
                        height: 173,
                      },
                      [theme.breakpoints.up('lg')]: {
                        height: 370,
                      },
                    }}
                    variant="rectangular"
                  />
                )}
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};
